<template>
  <page-edicion>
    <formulario-cliente
      :cliente="cliente"
      :imagenes="imagenes"
      :pais="pais"
      :contactos="contactos"
      @submit="actualizar"
    />
  </page-edicion>
</template>

<script>
import FormularioCliente from "./FormularioCliente.vue";
import * as clienteApi from "@/services/clientes.js";

export default {
  components: { FormularioCliente },
  data() {
    return {
      cliente: {},
      imagenes: {},
      pais: {},
      contactos: [],
    };
  },
  mounted() {
    this.cargar(this.$route.params.id);
  },
  methods: {
    cargar(id) {
      clienteApi
        .cargar(id)
        .then((response) => {
          this.cliente = response.cliente;
          this.imagenes = response.imagenes;
          this.pais = response.pais;
          this.contactos = response.contactos;
          this.asignarFavoritoPorDefecto(this.cliente.clienteContactoPorDefectoId);
        })
        .catch((err) => {
          this.$router.replace("/clientes");
        });
    },
    actualizar() {
      var data = {
        cliente: this.cliente,
        imagenes: this.imagenes,
        contactos: this.contactos,
      };
      clienteApi.actualizar(data).then(() => {
        this.$router.push({ path: "/clientes" });
      });
    },
    asignarFavoritoPorDefecto(idContacto) {
      for (var c in this.contactos) {
        var cont = this.contactos[c];
        if (cont.id == idContacto) {
          cont.default = true;
        }
      }
    },
  },
};
</script>
